<!-- =========================================================================================
  File Name: CustomerAlbums.vue
  Description: Customer Album List
========================================================================================== -->
<template>
	<div id="CustomerAlbums">
    <vx-card>
      <div class="text-center">
        <h4>{{ firstName }} {{ lastName }}'s Albums</h4>
      </div>
      <vs-row vs-justify="left">
        <vs-col :data="cAlbums" :key="indextr" v-for="(cAlbums, indextr) in customerAlbums" type="flex" vs-justify="center" vs-align="left" vs-w="3.8" class="cardx-holder">
            <vx-card
            class="main-nh-con"
            title-color="#fff"

            content-color="#fff">
                <div class="my-6">
                    <h5 class="mb-2 text-white">Album Name: {{ cAlbums.photobookName }}</h5>
                    <p class="text-white">Album ID: {{ cAlbums.id }}</p>
                </div>
                <vs-divider></vs-divider>
                <div class="flex justify-between flex-wrap">
                  <vx-tooltip delay=".5s" text="Delete">
                    <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" @click="confirmDeletion(cAlbums.id)"><vs-icon icon="delete_outline" size="25px" color="#fff"></vs-icon></vs-button>
                  </vx-tooltip>
                  <vx-tooltip delay=".5s" text="View">
                    <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" :href="`${pdfPath}${cAlbums.custID}albumPDF${cAlbums.id}.pdf`" target="_blank"><vs-icon icon="pageview" size="25px" color="#fff"></vs-icon></vs-button>
                  </vx-tooltip>
                </div>
            </vx-card>
      </vs-col>

      </vs-row>
    </vx-card>
	</div>
</template>
<script>

export default{
  data () {
	  return {
      pdfPath: 'https://create.2nomi.com/static/temp_pdfs/',
	    publicPath: process.env.BASE_URL,
      custID: this.$route.params.custID,
      firstName: this.$route.params.firstName,
      lastName: this.$route.params.lastName,
      customerAlbums: [],
      nursingHomes: [],
      activeConfirm:false,
      // for update nursing home
      activeDetailView: false,
      nhID: '',
      name: '',
      address: '',
      city: '',
      state: '',
      zipcode: '',
      couponLimit: '',
      updateNHLogo: '',
      errorList: [],
      //for adding new nursing home
      activeAddView: false,
      nh_name: '',
      nh_address: '',
      nh_city: '',
      nh_state: '',
      nh_zipcode: '',
      nh_couponLimit: '',
      nh_AddNHLogo: '',
      nh_ext_logo: ''
	  }
  },
  methods: {
    customerAlbumsList () {
      this.$vs.loading()
      this.$http.get('/user/photobook/?custID=' + this.$route.params.custID, { headers: {'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          if (response.data.messageType == 'success') {
            this.customerAlbums = JSON.parse(JSON.stringify(response.data.data))
            this.$vs.loading.close()
            return this.customerAlbums
          } else {
            this.$vs.loading.close()
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.customerAlbums
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.nursingHomes
        })
    },
    confirmDeletion (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure ?',
        text: 'You want to delete this Customer Album ?',
        accept: this.DeleteCustomerAlbum,
        acceptText: 'Delete',
        parameters: id
      })
      return true
    },
    DeleteCustomerAlbum (id) {
      console.log(id)
      //return false;
      this.$vs.loading()
      // const payload = JSON.stringify({ nursingHomeID: id })
      this.$http.delete('/user/photobook', {data: { photobookListID: id }})
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'Customer Album removed successfully.', color:'success', position:'top-right', icon:'check_box', time:5000})
            return this.customerAlbumsList()
          } else {

            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.customerAlbumsList()
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.customerAlbumsList()
        })
    }
    // viewNHDetails (nhInfo) {
    //   this.nhID = nhInfo.id
    //   this.name = nhInfo.name
    //   this.address = nhInfo.address
    //   this.city = nhInfo.city
    //   this.state = nhInfo.state
    //   this.zipcode = nhInfo.zipcode
    //   this.couponLimit = nhInfo.couponLimit
    //   console.log(nhInfo.nursingHomeLogo)
    //   this.$refs.NHLogo = nhInfo.nursingHomeLogo
    //   this.nh_ext_logo = nhInfo.nursingHomeLogo
    //   this.activeDetailView = true

    // },
    // logoChange () {
    //   this.updateNHLogo = this.$refs.NHLogo.filesx[0]
    // },
    // updateCustomerAlbum () {
    //   this.errorList = []

    //   this.$validator.validateAll().then(result => {
    //     if (result) {

    //       // if form have no errors
    //       this.$vs.loading()
    //       const formData = new FormData()
    //       formData.append('nursingHomeID', this.nhID)
    //       formData.append('name', this.name)
    //       formData.append('address', this.address)
    //       formData.append('city', this.city)
    //       formData.append('state', this.state)
    //       formData.append('zipcode', this.zipcode)
    //       formData.append('couponLimit', this.couponLimit)
    //       formData.append('nursingHomeLogo', this.updateNHLogo)
    //       this.$http.put('/nursing-home/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
    //         .then((response) => {
    //           this.$vs.loading.close()
    //           if (response.data.messageType == 'success') {
    //             this.$vs.notify({title:'Great!', text:'Nursing Home details updated.', color:'success', position:'top-right', icon:'check_box', time:5000})
    //             return this.nursingHomesList()
    //           } else {

    //             this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
    //             return this.nursingHomesList()
    //           }

    //         })
    //         .catch((error)   => {
    //           console.log(error)
    //           this.$vs.loading.close()
    //           this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
    //           return this.nursingHomesList()
    //         })
    //     } else {
    //       // form have errors
    //       this.activeDetailView = true
    //       return false
    //     }
    //   })
    // },
    // viewAddNHDialog () {
    //   this.activeAddView = true
    // },
    // addLogoChange () {
    //   this.nh_AddNHLogo = this.$refs.AddNHLogo.filesx[0]
    // },
    // addNursingHome () {
    //   this.errorList = []
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       if (!this.nh_AddNHLogo) {
    //         this.$vs.notify({title:'Attention!', text:'Please add a Nursing Home logo.', color:'warning', position:'top-right', icon:'error', time:5000})
    //         this.activeAddView = true
    //         return false
    //       }

    //       // if form have no errors
    //       this.$vs.loading()
    //       const formData = new FormData()
    //       formData.append('name', this.nh_name)
    //       formData.append('address', this.nh_address)
    //       formData.append('city', this.nh_city)
    //       formData.append('state', this.nh_state)
    //       formData.append('zipcode', this.nh_zipcode)
    //       formData.append('couponLimit', this.nh_couponLimit)
    //       formData.append('nursingHomeLogo', this.nh_AddNHLogo)
    //       this.$http.post('/nursing-home/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
    //         .then((response) => {
    //           this.$vs.loading.close()
    //           if (response.data.messageType == 'success') {
    //             this.$vs.notify({title:'Great!', text:'Nursing Home added.', color:'success', position:'top-right', icon:'check_box', time:5000})
    //             return location.reload()
    //             //return this.nursingHomesList()
    //           } else {

    //             this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
    //             return this.nursingHomesList()
    //           }

    //         })
    //         .catch((error)   => {
    //           console.log(error)
    //           this.$vs.loading.close()
    //           this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
    //           return this.nursingHomesList()
    //         })
    //     } else {
    //       this.activeAddView = true
    //       return false
    //       // form have errors
    //     }
    //   })
    // }
  },
  created () {
    this.customerAlbumsList()
  }
}
</script>
<style>
.cardx-holder{ margin: 0 15px 20px; }
.cardx-holder .main-nh-con{
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: contain !important;
}
.cardx-holder .main-nh-con .my-6{
  background: rgba(160, 97, 106, 0.8);
  border-radius: 5px;
  text-align: left;
  padding: 15px 20px;
}
.cardx-holder img.fixed-height {
    overflow: hidden;
}
.top-row .add-btn-top { padding: 16px 16px !important; margin: 0 0 30px !important;}
.con-exemple-prompt {  padding: 10px; padding-bottom: 0px;}
.vs-input { width: 100%; margin-top: 10px; padding:0 10px; float: left;}

.vx-card .vx-card__collapsible-content img.prompt-ext-logo {
    display: block;
    width: 100%;
    height: 120px;
}
.con-vs-dialog .vs-dialog .vs-dialog-text { padding: 0 10px 15px; float: left;}
.vs-component.vs-con-input-label.vs-input.w-50.vs-input-primary {width: 50%;}
.con-exemple-prompt {float: left; padding: 0 5px;}
.con-exemple-prompt .section-upload .con-input-upload {width: 300px; height: 110px;}
.con-vs-dialog .vs-dialog {max-width: 480px;}
.con-vs-dialog .vs-dialog .vs-dialog-text {
    float: left;
    width: 100%;
}
.con-vs-dialog .vs-dialog footer {
    padding: 1rem;
    float: left;
    width: 100%;
}
</style>
